export default {
    lightGray: '#898989',
    disabled: '#D3D3D3',
    darkGray: '#696969'
}